/** DESIGN_SYSTEM.md tokens — the only values new components may use. Mirrors tokens.scss. */
export const tokens = {
  color: {
    primary: "#1549F4", primaryPressed: "#0F3BCB",
    primaryMuted: "#4468DE", deepBlue: "#0576E2", // primaryMuted: pending primary button, white text 4.9:1, independent of the surface
    heading: "#0B1F4D", body: "#3D4766", muted: "#5B6582", placeholder: "#6B7694",
    page: "#EDF1FC", app: "#F5F7FD", surface: "#FFFFFF",
    divider: "#E3E8F5", controlBorder: "#8592B0", error: "#C53030",
    brandTeal: "#01C0B1", // decoration only, never a text colour
  },
  /** Public pages, colour option 4 (board 339): deep brand heading, grey-blue body, key-word gradient (large headings only), kickers in the logo blue. */
  publicText: { heading: "#0E2C8E", body: "#24304F", kicker: "#1549F4", keyEnd: "#00968A", keyMid: "#0576E2" },
  status: {
    danger: { fg: "#C53030", bg: "#FDECEC" },
    warning: { fg: "#9A5800", bg: "#FFF4E0" },
    ok: { fg: "#006A61", bg: "#E2F7F4" },
    info: { fg: "#1549F4", bg: "#EDF2FF", border: "#B7C8FA" },
    neutral: { fg: "#3D4766", bg: "#EEF1F7" },
  },
  accent: { fg: "#006A61", bg: "#E2F7F4" },
  gradient: { ltr: "linear-gradient(90deg, #1549F4 0%, #0576E2 55%, #01C0B1 100%)", rtl: "linear-gradient(270deg, #1549F4 0%, #0576E2 55%, #01C0B1 100%)" },
  font: { family: '"Inter", "Rubik", sans-serif', weights: [400, 500, 600, 700, 800] },
  type: { pageTitle: 30, pageTitlePhone: 24, sectionTitle: 20, body: 15, input: 16, small: 13, label: 12 },
  space: [0, 4, 8, 12, 16, 20, 24, 32, 40, 48, 64],
  radius: { control: 14, card: 24, pill: 999 },
  elevation: {
    none: "none",
    card: "0 1px 2px rgba(11,31,77,.06), 0 2px 8px rgba(11,31,77,.06)",
    floating: "0 6px 24px rgba(11,31,77,.14)",
    dialog: "0 18px 48px rgba(11,31,77,.24)",
  },
  motion: { fast: 150, base: 200, slow: 280, easing: "cubic-bezier(.2,.8,.2,1)" },
  tap: 48,
  controlHeight: 44,
  breakpoint: { phone: 760 },
} as const;
